import { parseYouTubeVideoId } from 'fym-shared/src/music24/addedAssets';
import type { YouTubeCandidate } from 'fym-shared/src/music24/musicVideoApi';

export interface YouTubeLinkState {
  /** The video id of the text, or null. */
  videoId: string | null;
  /** "This is not a YouTube video link." shows for a text that is not empty and has no id. */
  notYouTube: boolean;
  /**
   * The video is not one of the videos of the connected channel (design a3): the info note says
   * that we show it as "On YouTube" but can not show its views.
   */
  otherChannel: boolean;
}

/** The state of the "YouTube link" field (design a3, the parse rule of `parseYouTubeVideoId`). Pure. */
export function youtubeLinkState(
  text: string,
  candidates: readonly Pick<YouTubeCandidate, 'videoId'>[]
): YouTubeLinkState {
  const trimmed = text.trim();
  const videoId = trimmed === '' ? null : parseYouTubeVideoId(trimmed);
  return {
    videoId,
    notYouTube: trimmed !== '' && videoId === null,
    otherChannel: videoId !== null && !candidates.some((candidate) => candidate.videoId === videoId),
  };
}

/** The pre-selected video of the channel list (design a2): the best match, else nothing. Pure. */
export function defaultYouTubePick(candidates: readonly YouTubeCandidate[]): string | null {
  return candidates.find((candidate) => candidate.bestMatch)?.videoId ?? null;
}

/** The picture of a video that has no thumbnail in the answer (a pasted link). */
export function youtubeThumbnailUrl(videoId: string): string {
  return `https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`;
}
